var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2415 5109 c-27 -5 -489 -114 -1025 -244 -874 -211 -978 -238 -1010 -263 -43 -35 -66 -94 -56 -146 10 -52 67 -113 120 -126 22 -6 49 -13 59 -16 16 -5 17 -28 17 -293 l0 -288 -49 -49 c-93 -94 -96 -212 -6 -311 l44 -49 -81 -320 c-84 -338 -88 -367 -47 -410 22 -24 23 -24 260 -24 l238 0 20 25 c38 49 35 68 -49 405 l-81 323 34 36 c53 55 71 98 71 166 0 71 -25 126 -78 173 l-36 31 0 262 c0 244 1 261 17 257 10 -3 155 -38 323 -78 168 -40 307 -75 309 -76 2 -2 -13 -44 -34 -94 -114 -283 -126 -590 -35 -871 121 -368 406 -664 775 -802 155 -58 235 -71 435 -71 161 0 198 3 280 23 385 96 692 335 860 671 168 337 183 698 44 1040 -19 47 -35 89 -37 94 -1 5 221 63 493 130 272 67 505 127 517 134 12 7 34 28 49 47 31 41 36 119 10 159 -43 67 -27 62 -1052 310 -533 129 -996 239 -1028 245 -69 13 -198 13 -271 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1905 c-512 -88 -935 -462 -1071 -950 -49 -177 -66 -457 -34 -580 50 -192 216 -335 412 -356 112 -11 3509 -11 3611 1 217 25 389 189 423 405 21 136 -8 402 -62 572 -65 204 -172 377 -329 533 -223 224 -509 360 -810 385 l-75 7 -470 -471 c-258 -259 -474 -471 -480 -471 -6 0 -222 212 -480 470 l-470 470 -45 -1 c-25 -1 -79 -7 -120 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8aad1a649de4b50acee9f7af5a53710c.svg";
export { ForwardRef as ReactComponent };